export default "__VITE_ASSET__CfD1dF0r__"